import {
  RadioGroup,
  type RadioGroupOnChangeData,
} from '@fluentui/react-components';
import { useOtherInfoContext } from '../OtherInfoContext';
import { RadioOptions } from '../RadioOptions';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

interface RadioButtonFieldProps extends FieldComponentProps {
  metadata: any;
}

export const RadioButtonField = ({
  field,
  fieldValue,
  isFieldDisabled,
  validationMessage,
  metadata,
}: RadioButtonFieldProps) => {
  const { handleOtherInfoChange } = useOtherInfoContext();

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <RadioGroup
        required={field.mandatory}
        value={fieldValue == null ? '' : String(fieldValue)}
        onChange={(_, option: RadioGroupOnChangeData) => {
          const value = option?.value;
          handleOtherInfoChange(field.name, value);
        }}
        layout={
          field.optionsLayout === 'Horizontal'
            ? 'horizontal'
            : field.optionsLayout === 'HorizontalStacked'
            ? 'horizontal-stacked'
            : 'vertical'
        }
        disabled={isFieldDisabled}
      >
        <RadioOptions metadata={metadata} field={field} />
      </RadioGroup>
    </FieldWrapper>
  );
};
